import { sampleDrawLayer } from 'components/MapComponent/constants/sampleLayers';
import { apiPrefix } from 'constants/apiConfig';
import { LayerConfiguration } from './mapEventsEffectTypes';
import { eventTileHazards } from 'components/MapComponent/constants/eventHazards';

import { NWS_ALERTS } from 'slices/mapSlice';

export const polygon_events_layer_id = 'polygon_events_layer_id';
export const polygon_source_layer = 'public.polygon_events_layer';
export const polygon_events_source_id = 'polygon_events_source_id';

const eventTypesToMapboxColorExpression = () => {
  const expression = [
    'match',
    ['get', 'hazard_name'],
    ...eventTileHazards.map((t) => [t.hazard_name, t.hazard_color]).flat(),
    'Wild Fires',
    '#FF0000',
    '#FFFF00' /* other */,
  ];
  return expression;
};

export function addNwsAndWildfiresLayers({
  addMapEventHandlers,
  addVectorSource,
  checkLayerToggle,
  endDatetime,
  formattedDatetime,
}: {
  addMapEventHandlers: (layerConfig: LayerConfiguration) => void;
  addVectorSource: (sourceId: string, tiles: string) => void;
  checkLayerToggle: (layerName: string) => boolean;
  endDatetime: string;
  formattedDatetime: string;
}) {
  const polygonTiles = `${apiPrefix}/event_tiles/${polygon_source_layer}/{z}/{x}/{y}.pbf`;
  const hazardNameFilterList = "'Wild Fires'";

  const tilesPath = `${polygonTiles}?datetime_selected=${formattedDatetime}&end_datetime=${endDatetime}&hazard_name_filter_list=${hazardNameFilterList}`;

  if (checkLayerToggle(NWS_ALERTS)) {
    addVectorSource(polygon_events_source_id, tilesPath);

    const polygonEventsLayerConfig = {
      ...sampleDrawLayer,
      id: polygon_events_layer_id,
      source: polygon_events_source_id,
      'source-layer': polygon_source_layer,
      generateId: true,
      layout: {
        visibility: 'visible',
      },
      paint: {
        ...sampleDrawLayer.paint,
        'fill-color': eventTypesToMapboxColorExpression(),
      },
      metadata: {
        eventlayer: true,
        usermade: undefined,
      },
    };

    addMapEventHandlers(polygonEventsLayerConfig);
  }
}

export function updateNwsAndWildfiresFilters(
  setFilter: (layerId: UUID, filter: any[]) => void,
  eventToggles: any[]
) {
  setFilter(polygon_events_layer_id, [
    'in',
    'hazard_data_category',
    ...eventToggles.map((t) => t.name),
  ]);
}

export function removeNwsAndWildfiresLayers({
  removeLayer,
  removeSource,
}: {
  removeLayer: (layerId: string) => void;
  removeSource: (sourceId: string) => void;
}) {
  removeLayer(polygon_events_layer_id);
  removeSource(polygon_events_source_id);
}

export function setNwsAndWildfiresLayersVisibility({
  setLayerVisibility,
  isVisible,
}: {
  setLayerVisibility: (layerId: string, visibility: boolean) => void;
  isVisible: boolean;
}) {
  setLayerVisibility(polygon_events_layer_id, isVisible);
}

export function checkNwsAndWildfiresLayersVisible(
  checkLayerVisible: (layerId: string) => boolean
) {
  return checkLayerVisible(polygon_events_layer_id);
}
